import styled from 'styled-components';

import Modal, { ModalHeading } from 'components/modal';

export const ActionsContainer = styled.div`
  display: flex;
`;
export const ActionContainer = styled.div`
  padding: 0 1rem;
  display: flex;
`;

export const StyledModalHeading = styled(ModalHeading)``;

export const StyledModal = styled(Modal)``;
